import * as Actions from './FinancialPlanGoalDropdownActions';
import * as FinancialPlanActions from '../FinancialPlan/FinancialPlanActions';

const defined = object => object || {};

export const DEFAULT_DROPDOWN_SELECTION = {
  GoalName: 'Summary',
  GoalId: 'summary',
  icon: 'fa fa-location-arrow',
};

const DEFAULT_STATE = {};

export default (state = DEFAULT_STATE, action) => {
  const {
    type,
  } = action;

  switch (type) {
    case FinancialPlanActions.RECEIVE_DATA: {
      const goals = action.data.Goals;
      const { clientId } = action;
      const goalId = defined(state[clientId]).goalId || null;
      const hasGoalIdSet = goals.find(goal => goal.GoalId === goalId);

      if (!hasGoalIdSet) {
        return {
          ...state,
          [action.clientId]: {
            ...defined(state[action.clientId]),
            goalId: DEFAULT_DROPDOWN_SELECTION.GoalId,
            goals: [
              DEFAULT_DROPDOWN_SELECTION,
              ...goals,
            ],
          },
        };
      }

      return {
        ...state,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          goals: [
            DEFAULT_DROPDOWN_SELECTION,
            ...goals,
          ],
        },
      };
    }

    case Actions.SET_GOAL_ID: {
      return {
        ...state,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          goalId: action.goalId,
        },
      };
    }

    case Actions.SET_SUB_GOAL_TYPE: {
      return {
        ...state,
        [action.clientId]: {
          ...defined(state[action.clientId]),
          subGoalTypeId: action.subGoalTypeId,
        },
      };
    }

    case FinancialPlanActions.CLEAR_DATA: {
      return DEFAULT_STATE;
    }

    default: {
      return state;
    }
  }
};
